import { FactCardProps } from '@/components/molecules/factCard/FactCard'
import FactCardSliderBlock from './FactCardSliderBlock'
import { ButtonProps } from '@/components/atoms/button/Button'

export default function factCardSliderBlockFactory(
  data: any,
  key: string | number,
) {
  const content = data.content.properties
  const cardBackgroundColor = content?.cardBackgroundColor?.value
  // Map the card items to extract required data for the FactCardSliderBlock
  const cardMapper = (
    items: any[] = [],
    cardBackgroundColor: string,
  ): FactCardProps[] =>
    items.map(({ content }) => ({
      title: content?.properties?.title,
      subTitle: content?.properties?.subTitle,
      cardBackgroundColor,
      value: content?.properties?.value,
    }))

  const readMoreButton: ButtonProps = content?.button?.[0]
    ? {
        text: content.button[0]?.title,
        target: content.button[0]?.target,
        url: content.button[0]?.route?.path,
      }
    : {}

  const mappedCards = cardMapper(content?.items?.items, cardBackgroundColor)
  return (
    <FactCardSliderBlock
      key={`image-text-block-${key}`}
      title={content?.title?.markup}
      cards={mappedCards}
      readMoreButton={readMoreButton}
      cardBackgroundColor={content?.cardBackgroundColor?.value}
    />
  )
}
